import supportArticle, {
  QueryParameters,
} from "@faire/web-api/routes/support/articles/articleId";

import { getSettingInsiderThresholdForNonInsidersEnabled } from "@faire/retailer/settings/getSettingInsiderThresholdForNonInsidersEnabled";

const INSIDER_NAM_HELP_CENTER_ARTICLE_ID = "4406840862747";
const INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID = "19894043020059";
const INSIDER_NON_THRESHOLD_EUROPE_HELP_CENTER_ARTICLE_ID = "4418050425115";

export const getInsiderHelpCenterArticleUrl = (
  isAmerican: boolean,
  queryParams?: Partial<QueryParameters>
) => {
  if (getSettingInsiderThresholdForNonInsidersEnabled()) {
    return supportArticle(
      isAmerican
        ? INSIDER_NAM_HELP_CENTER_ARTICLE_ID
        : INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID,
      queryParams
    );
  }

  return supportArticle(
    isAmerican
      ? INSIDER_NAM_HELP_CENTER_ARTICLE_ID
      : INSIDER_NON_THRESHOLD_EUROPE_HELP_CENTER_ARTICLE_ID,
    queryParams
  );
};
